import React, { useRef } from "react"
import { useThree, useFrame } from "@react-three/fiber"
import { useGLTF } from '@react-three/drei'

export default function StickerModel(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF('/FuguSticker.glb')

  const { viewport } = useThree();
  const { width, height } = viewport;

  // Calcula la posición del modelo responsive al tamaño de la ventana
  const positionX = width * 0.4;
  const positionY = height * -0.25;
  const rotationY = Math.random() * Math.PI * 2;

  const scaleResponsive = width * 0.1;
  const scale = Math.min(scaleResponsive, 0.5);

  useFrame(() => {
    group.current.rotation.y += 0.005;
  });

  return (
    <group
      ref={group}
      {...props}
      dispose={null}
      position={[positionX, positionY, 0]}
      rotation-x={Math.PI / 2}
      rotation-y={rotationY}
    >
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Pegatina.geometry}
        material={materials.Pegata_v01}
        scale={scale}
      />
    </group>
  );
}

useGLTF.preload('/FuguSticker.glb')
